import { Controller } from "@hotwired/stimulus";

export class DropdownSelectorController extends Controller {
  static targets = ["inputField", "form", "list", "select"];

  lastToggleTarget = null;

  connect() {
    document.addEventListener("click", this.#handleClickOutside);
  }

  disconnect() {
    document.removeEventListener("click", this.#handleClickOutside);
  }

  #handleClickOutside = (event) => {
    if (!this.hasListTarget) {
      return;
    }

    const isHidden = this.listTarget.classList.contains("tw:opacity-0");

    if (isHidden) {
      return;
    }

    if (!this.element.contains(event.target)) {
      this.toggleVisibility();
    }
  };

  toggleVisibility(event) {
    let target;

    if (event?.currentTarget) {
      target = event.currentTarget;
      this.lastToggleTarget = target;
    } else {
      target = this.lastToggleTarget;
    }

    if (target) {
      if (target.hasAttribute("open")) {
        target.removeAttribute("open");
      } else {
        target.setAttribute("open", true);
      }
    }
    this.listTarget.classList.toggle("tw:opacity-0");
    this.listTarget.classList.toggle("tw:pointer-events-none");
  }

  changeLanguage(event) {
    event.preventDefault();
    const value = event.currentTarget.getAttribute("value");
    this.selectTarget.value = value;
    this.formTarget.submit();
  }
}
